var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-dialog',{attrs:{"show-dialog":_vm.showDialog,"text":_vm.text,"width":400}},[(_vm.loading)?[_c('asc-spinner',{attrs:{"loading":""}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }